// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__forgotpwd-btn__t8Qwf {
  width: 100%;
  border-radius: 50px;
}
.index-module__action-btn__container__ojt34 {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.index-module__password-form-button__zNaWx {
  width: 100%;
  border-radius: 50px;
}
.index-module__password-btn-container__sPwYT {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/SignIn/RequestPasswordReset/index.module.less"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;AACf","sourcesContent":[".forgotpwd-btn {\n  width: 100%;\n  border-radius: 50px;\n}\n.action-btn__container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n.password-form-button {\n  width: 100%;\n  border-radius: 50px;\n}\n.password-btn-container {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"forgotpwd-btn": `index-module__forgotpwd-btn__t8Qwf`,
	"action-btn__container": `index-module__action-btn__container__ojt34`,
	"password-form-button": `index-module__password-form-button__zNaWx`,
	"password-btn-container": `index-module__password-btn-container__sPwYT`
};
export default ___CSS_LOADER_EXPORT___;
